/**
 * TODO: let's import from @metriport/shared when available there. We accepted this as a compromise
 * for speed considering HIEs RARELY change - but still should be imported from OSS.
 */
export enum MedicalDataSource {
  COMMONWELL = "COMMONWELL",
  CAREQUALITY = "CAREQUALITY",
  EHEX = "EHEX",
}
